var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-json-editor',_vm._b({attrs:{"mode":_vm.innerMode},model:{value:(_vm.nativeValue),callback:function ($$v) {_vm.nativeValue=$$v},expression:"nativeValue"}},'vue-json-editor',_vm.$reverseMerge(_vm.innerMeta.conf, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }